export interface KontostandVorschauEingabe {
  previousBalanceUsd: number;
  previousMixedRate: number;
  dealUsd: number;
  dealRate: number;
}

/** Ausschliesslich Anzeigehilfe; der beim Speichern gelieferte Snapshot bleibt massgeblich. */
export interface KontostandVorschau {
  expectedBalanceUsd: number;
  mixedRate: number;
}

export function kontostandVorschau(
  eingabe: KontostandVorschauEingabe | null,
): KontostandVorschau | null {
  if (eingabe === null) return null;
  const expectedBalanceUsd = Math.round((eingabe.previousBalanceUsd + eingabe.dealUsd) * 100) / 100;
  const mixedRate = Math.round(
    ((eingabe.previousBalanceUsd * eingabe.previousMixedRate) + (eingabe.dealUsd * eingabe.dealRate)) /
      expectedBalanceUsd *
      1_000_000,
  ) / 1_000_000;
  return { expectedBalanceUsd, mixedRate };
}

/**
 * Der Mischkurs eines Kontos ist nur bei Bestand > 0 aussagekraeftig. Ein leeres Konto (z. B. nach
 * Eroeffnung mit dem Platzhalterkurs 1.000000) zeigt keinen Kurs; gespeichert bleibt der Wert.
 * Gilt fuer Konto-Mischkurse, nicht fuer den Gesamtmischkurs ueber alle Konten.
 */
export function kontoMischkursVerfuegbar(balanceUsd: string | null | undefined): boolean {
  return balanceUsd !== null && balanceUsd !== undefined && Number(balanceUsd) > 0;
}
